import {AccountId, EngagementId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const auditPortalConnections = typedQuery(["tprm", "auditPortalConnections"], async () => {
  return await api.tprm.auditPortalConnections.list();
});

export const infloEngagements = typedQuery(
  ["tprm", "infloEngagements", param<AccountId>("accountId")],
  async accountId => {
    return await api.tprm.auditPortalConnections.listInfloEngagements(accountId);
  },
);

export const engagementAuditPortal = typedQuery(
  ["tprm", "engagementAuditPortal", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.auditPortalConnections.getEngagementAuditPortal(engagementId);
  },
);

export const infloTeam = typedQuery(["tprm", "infloTeam", param<EngagementId>("engagementId")], async engagementId => {
  return await api.tprm.auditPortalConnections.listInfloTeam(engagementId);
});

export const auditPortalRequests = typedQuery(
  ["tprm", "auditPortalRequests", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.auditPortalConnections.listRequests(engagementId);
  },
);
